<flex-select *ngIf="ready"
            [placeholder]="placeholder" 
              [formControl]="flexSelect" 
              [itemList] = "list"
              [enabled] = "enabled"
              [itemTemplate] = "itemTemplate"
              [options] = "flexSelectOptions"
              [multiple]="multiple">
  <ng-template #itemTemplate let-item="item" let-isTruncated="truncate">
    <app-text-truncate *ngIf="isTruncated;else NotTruncate" [text]="item?.name"></app-text-truncate>
    <ng-template #NotTruncate><span [innerHtml]="item?.name || ''"></span></ng-template>
  </ng-template>
</flex-select>
